export default __webpack_public_path__ + "static/media/delmar.a5c031ba.png";